module.exports = __webpack_public_path__ + "static/media/beer.913564d2.svg";